module.exports = __webpack_public_path__ + "61b43b47c26c618d211a196c27e001ba.svg";